export default "__VITE_ASSET__o$aNyGkf__"